import { createBrowserRouter } from 'react-router'

import { privateRoutes } from './private.routes'
import { publicRoutes } from './public.routes'
import { RootLayout } from './RootLayout'

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [...publicRoutes, ...privateRoutes],
  },
])
